<template>
  <div>    
  </div>
</template>

<script>
import { request } from '../../store.js';
export default {
  props: {
    status: {
      type: Number,
    },
    store: {
      type: String
    }
  },
  name: 'AttendStatusTab',
  created() {
    console.log(this.store)
    console.log(this.status)
  },
  mounted() {
    console.log(this.store)
    console.log(this.status)
  },
  data () {
    return {

    }
  }
}
</script>

<style 
  lang="css" 
  scoped>
</style>